import { render, staticRenderFns } from "./DefaultServicePage.vue?vue&type=template&id=1dd3735e"
import script from "./DefaultServicePage.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultServicePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports